import { JQElementHelper } from "../../lib/JQElementHelper";
import { AxDropdownInteraction } from './AxDropdownInteraction';
import { BehaviorSubject, Subject } from "rxjs";
import tippy from 'tippy.js';
export class AxDropdownEvents {
    constructor(selector, options) {
        this.jqElementHelper = new JQElementHelper();
        this.$parents = $(selector);
        this.interaction = new AxDropdownInteraction(options);
        this.options = options;
        this.interaction.openSubject = new Subject();
        this.interaction.onShownSubject = new Subject();
        this.interaction.changeSubject = new BehaviorSubject(null);
        this.createIntersectionObserver();
        this.jqElementHelper.iterateSelector(this.$parents, ($elem) => {
            const $menu = $elem.find('.ax-dropdown__menu');
            const isMultiSelect = this.interaction.hasMultiSelectClass($elem);
            const instance = tippy($elem[0], {
                content: $menu[0],
                allowHTML: true,
                placement: 'bottom',
                trigger: 'click',
                arrow: false,
                interactive: true,
                maxWidth: 'none',
                animation: false,
                onShow: (instance) => {
                    let $parent = $(instance.reference);
                    let $popperInstance = $(instance.popper);
                    instance.popper.style.width = instance.reference.getBoundingClientRect().width + 'px';
                    this.interaction.afterOpen($parent, $popperInstance);
                },
                onShown(instance) {
                    let $parent = $(instance.reference);
                    let $popperInstance = $(instance.popper);
                    //instance.popper.style.width = instance.reference.getBoundingClientRect().width + 'px';
                    this.interaction.afterOnShown($parent, $popperInstance);
                },
                appendTo: () => document.body,
            });
            const $parent = $(instance.reference);
            this.assignIntersectionObserver($parent);
            const $popperInstance = $(instance.popper);
            let $selectedList = $popperInstance.find('.ax-dropdown__item.selected');
            if ($selectedList.length > 0) {
                for (let selected of $selectedList) {
                    const $selected = $(selected);
                    if (isMultiSelect) {
                        $selected.removeClass('selected');
                    }
                    this.interaction.select($selected, $elem);
                }
            }
            this.assignSelectEvent($parent, $popperInstance);
            this.assignSearchEvent($parent, $popperInstance);
            this.assignMultiSelectDelete($parent, $popperInstance);
            this.assignResetEvent($parent, $popperInstance);
        });
    }
    assignResetEvent($parent, $popperElem) {
        $parent.on("click", ".ax-dropdown--reset", (event) => {
            $parent.find('.ax-dropdown__trigger').removeClass('has-selection');
            $parent.find(".ax-dropdown__selection").text("");
            let currentTarget = $popperElem.find(".ax-dropdown__item.selected");
            if (currentTarget.length > 0) {
                currentTarget.removeClass("selected");
            }
            $(event.currentTarget).remove();
        });
    }
    assignMultiSelectDelete($parent, $popperElem) {
        const hasMultiSelect = this.options.multiSelect && $parent.hasClass('ax-dropdown--multiselect');
        if (hasMultiSelect) {
            $parent.on("click", ".ax-dropdown__muli-remove", (e) => {
                e.preventDefault();
                const id = $(e.currentTarget).parent().attr("data-value");
                this.interaction.deleteMultiSelection($parent, id, $popperElem);
            });
        }
    }
    assignSearchEvent($parent, $popperElem) {
        if (this.options.searchBar || $parent.hasClass('ax-dropdown--hero')) {
            $popperElem.find(".ax-dropdown__search-input").on("keyup", e => {
                e.preventDefault();
                const $target = $(e.delegateTarget);
                this.interaction.search($target, $parent, $popperElem);
            });
        }
    }
    assignSelectEvent($parent, $popperElem) {
        const hasMultiSelect = this.options.multiSelect && $parent.hasClass('ax-dropdown--multiselect');
        if (this.options.multiSelect && !hasMultiSelect) {
            console.warn(`Element is set to multiselect but doesn't contain multiselect class`);
            console.warn($parent);
        }
        $popperElem.find(".ax-dropdown__menu").on("click", '.ax-dropdown__item:not(.ax-dropdown__search)', (e) => {
            const $target = $(e.currentTarget);
            this.interaction.select($target, $parent);
        });
    }
    createIntersectionObserver() {
        if (!this.options.hideOnOutOfScreen)
            return;
        const options = {
            root: window.document,
            rootMargin: "0px",
            threshold: 1,
        };
        const interSectionCallback = (entries, observer) => {
            for (let entry of entries) {
                this.interaction.close($(entry.target));
            }
        };
        this.observer = new IntersectionObserver(interSectionCallback, options);
    }
    assignIntersectionObserver($parent) {
        if (this.options.hideOnOutOfScreen) {
            this.observer.observe($parent[0]);
        }
    }
}
